export function toDataUri(base64) {
  if (!base64) return null;
  if (base64.startsWith('data:')) return base64;
  return `data:image/png;base64,${base64}`;
}

export async function dataUrlToFile(dataUrl, filename = 'image.png') {
  const response = await fetch(dataUrl);
  const blob = await response.blob();
  const mimeType = blob.type || 'image/png';
  return new File([blob], filename, { type: mimeType });
}

export function readFileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];
export const ACCEPTED_IMAGE_EXTENSIONS = '.jpg,.jpeg,.png';

export function validateImageFile(file) {
  if (!file) return 'Please select an image file.';
  if (!ACCEPTED_IMAGE_TYPES.includes(file.type)) {
    return 'Only JPG and PNG images are supported.';
  }
  if (file.size > 15 * 1024 * 1024) {
    return 'Image must be smaller than 15 MB.';
  }
  return null;
}
